import React, { Component } from "react";
import { Provider } from "react-redux";
import { homeAPI } from "../../api/api";
import { Redirect } from "react-router";
import { homeStore, history } from "../../store/store";
import Topbar from "../Topbar/Topbar.component";
import HomeRouter from "../HomeRouter/HomeRouter.component";
import { connect } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import "./HomePage.component.scss";

export interface HomePageProps {}

class HomePage extends Component<HomePageProps, {}> {
    render() {
        return !homeAPI.getLoginStatus().loggedIn ? (
            <Redirect to="/login" />
        ) : (
            <Provider store={homeStore}>
                <ConnectedRouter history={history}>
                    <Topbar />
                    <div className="router-content">
                        <HomeRouter />
                    </div>
                </ConnectedRouter>
            </Provider>
        );
    }
}

const mapDispatchToProps = {};

export default connect(null, mapDispatchToProps)(HomePage);
